/* eslint-disable react/prop-types */
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";

import { useState, useEffect, useRef } from "react";

import { useClient } from "../../../hooks/useClient";

import {
  BoxChecket,
  BoxNotChecket,
  LeftBackArrow,
} from "../../../assets/svgs/icons";

import {
  getBusinessByLogin,
  getBusinessByClientId,
  postBusiness,
} from "../../../services/business";

import { notifyErrorCustom, notifySuccessCustom } from "../../../utils/notify";

import {
  BrandingService,
  VoiceToneService,
  BrandingArchetypeService,
  BusinessService,
  LogosService,
  UserAccountsService,
} from "../../../services/";
import {
  getLogosByClientBase64,
  getLogosById,
  getLogosUserBase64,
} from "../../../services/logosService";
import { useTranslation } from "react-i18next";
import Loading from "../../../components/Loading";
import ModalValidParameter from "../../../components/ModalValidParameter";

const STEPS = {
  STEP_NEW_CAMPAIGN: "NewCampaign",
  STEP_NEW_CAMPAIGN_SUCCESS: "StepNewCampaignSuccess",
  STEP_PAGE_PARAMETERS: "StepPageParameters",
};

function StepNewCampaignSuccess({
  setStep,
  state,
  setUncompletedSteps,
  campaignItem,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { clientData } = useClient();

  const [isBranding, setIsBranding] = useState(false);
  const [isLogo, setIsLogo] = useState(false);
  const [isCommunication, setIsCommunication] = useState(false);
  const [isEffect, setIsEffect] = useState(false);
  const [isArchetype, setIsArchetype] = useState(false);
  const [isPreferences, setIsPreferences] = useState(false);
  const [isReferences, setIsReferences] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [businessByLoginData, setBusinessByLoginData] = useState({});
  const [businessByClient, setBusinessByClient] = useState({});
  const [logoByClient, setLogoByClient] = useState({});

  const verifyParameterizationCompleted = useRef([]);
  const campaignItemRef = useRef(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);

    if (clientData?.uuid) {
      const { data, responseStatus } = await getBusinessByClientId(
        clientData?.uuid
      );

      const { data: dataLogo, responseStatus: responseLogo } =
        await getLogosByClientBase64(clientData?.uuid);

      if (responseStatus === 200) {
        setBusinessByClient(data[0]);
      }
      if (responseLogo === 200) {
        setLogoByClient(dataLogo[0]);
      }

      const verifyParameterizationCompletedResponse =
        await UserAccountsService.getUserAccountsParameterizationCompleted();

      verifyParameterizationCompleted.current =
        verifyParameterizationCompletedResponse.data;
    } else {
      const verifyParameterizationCompletedResponse =
        await UserAccountsService.getUserAccountsParameterizationCompleted();

      verifyParameterizationCompleted.current =
        verifyParameterizationCompletedResponse.data;

      const { data: dataLogo, responseStatus: responseLogo } =
        await getLogosUserBase64();

      const { data, responseStatus } = await getBusinessByLogin();

      if (responseStatus === 200) {
        setBusinessByLoginData(data[0]);
      }

      if (responseLogo === 200) {
        setLogoByClient(dataLogo[0]);
      }
    }
    setLoading(false);
  };

  const nextButton = async (navigation) => {
    if (navigation === "nextNewParameters") {
      setStep(STEPS.STEP_PAGE_PARAMETERS);
    }
    if (navigation === "back") {
      setStep(STEPS.STEP_NEW_CAMPAIGN);
    }
  };

  const handleCheckt = (param) => {
    if (param === "branding") {
      setIsBranding(!isBranding);
    }
    if (param === "logo") {
      setIsLogo(!isLogo);
    }
    if (param === "comunicacao") {
      setIsCommunication(!isCommunication);
    }
    if (param === "efeitos") {
      setIsEffect(!isEffect);
    }
    if (param === "arquetipo") {
      setIsArchetype(!isArchetype);
    }
    if (param === "preferencias") {
      setIsPreferences(!isPreferences);
    }
    if (param === "referencias") {
      setIsReferences(!isReferences);
    }
  };

  const postLogos = async () => {
    let businessId;

    if (clientData?.uuid) {
      const { data } = await getBusinessByClientId(clientData?.uuid);
      businessId = data[0]?.uuid;
    } else {
      const { data } = await BusinessService.getBusinessByLogin();
      businessId = data[0]?.uuid;
    }

    let body = {};

    if (clientData?.uuid) {
      body = {
        businessId: businessId,
        businessClientId: clientData?.uuid,
        campaignId: campaignItem?.uuid,
        description: logoByClient?.description,
        fileFormat: logoByClient?.fileFormat,
        fileContentType: logoByClient?.fileContentType,
        fileBase64: logoByClient?.fileBase64,
      };
    } else {
      body = {
        businessId: businessId,
        campaignId: campaignItem?.uuid,
        description: logoByClient?.description,
        fileFormat: logoByClient?.fileFormat,
        fileContentType: logoByClient?.fileContentType,
        fileBase64: logoByClient?.fileBase64,
      };
    }

    await LogosService.postLogo(body);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const wantToKeepParameters = async (toKeepParametersSelected) => {
    let newState = await state;
    let bodyNewBusiness;

    if (clientData?.uuid) {
      bodyNewBusiness = {
        businessNicheId: businessByClient.businessNicheId,
        campaignId: newState?.uuid,
        subNiche: businessByClient?.subNiche,
        description: businessByClient.description,
        businessClientId: clientData?.uuid,
      };
    } else {
      bodyNewBusiness = {
        businessNicheId: businessByLoginData?.businessNicheId,
        campaignId: newState?.uuid,
        subNiche: businessByLoginData?.subNiche,
        description: businessByLoginData?.description,
        guestId: JSON.parse(window.localStorage.getItem("userData"))
          .guestUserId,
      };
    }

    const postBusinessResponse = await postBusiness(bodyNewBusiness);

    campaignItemRef.current = {
      businessId: postBusinessResponse.data.uuid,
      campaignId: newState?.uuid,
    };

    if (postBusinessResponse?.responseStatus === 200) {
      if (toKeepParametersSelected) {
        let getBrandingByLoginDataResponse;

        if (clientData?.uuid) {
          getBrandingByLoginDataResponse =
            await BrandingService.getAllBrandingByBusinessId(
              businessByClient.uuid
            );
        } else {
          getBrandingByLoginDataResponse =
            await BrandingService.getAllBrandingByBusiness();
        }

        const bodyNewBranding = {
          businessId: postBusinessResponse.data.uuid,
          primaryColor: getBrandingByLoginDataResponse.data[0].primaryColor,
          secondaryColor: getBrandingByLoginDataResponse.data[0].secondaryColor,
          tertiaryColor: getBrandingByLoginDataResponse.data[0].tertiaryColor,
          complementaryColor1:
            getBrandingByLoginDataResponse.data[0].complementaryColor1,
          complementaryColor2:
            getBrandingByLoginDataResponse.data[0].complementaryColor2,
          fontTitleId: getBrandingByLoginDataResponse.data[0].fontTitleId,
          fontTitleByUploaded:
            getBrandingByLoginDataResponse.data[0].fontTitleByUploaded,
          fontSubtitleId: getBrandingByLoginDataResponse.data[0].fontSubtitleId,
          fontSubtitleByUploaded:
            getBrandingByLoginDataResponse.data[0].fontSubtitleByUploaded,
          fontTextId: getBrandingByLoginDataResponse.data[0].fontTextId,
          fontTextByUploaded:
            getBrandingByLoginDataResponse.data[0].fontTextByUploaded,
        };

        const postBrandingResponse =
          await BrandingService.postBrandingByBusinessId(bodyNewBranding);

        let getVoiceToneByLogin;

        if (clientData?.uuid) {
          getVoiceToneByLogin = await VoiceToneService.getVoiceToneByBusiness(
            businessByClient.uuid
          );
        } else {
          getVoiceToneByLogin =
            await VoiceToneService.getAllVoiceToneByBusiness();
        }

        if (getVoiceToneByLogin.data.length > 0) {
          const bodyNewVoiceTone = {
            businessId: postBusinessResponse.data.uuid,
            tone: getVoiceToneByLogin.data[0]?.tone,
            description: getVoiceToneByLogin.data[0].description,
          };

          const postVoiceToneResponse =
            await VoiceToneService.postVoiceToneByLogin(bodyNewVoiceTone);
        }

        let getArchetypeByLogin;
        if (clientData?.uuid) {
          getArchetypeByLogin =
            await BrandingArchetypeService.getBrandingArchetypeByBusinessId(
              businessByClient.uuid
            );
        } else {
          getArchetypeByLogin =
            await BrandingArchetypeService.getBrandingArchetypeByBusiness();
        }

        const bodyNewArchetype = {
          businessId: postBusinessResponse.data.uuid,
          bpsClassicOrModern: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.bpsClassicOrModern
            : getArchetypeByLogin.data.bpsClassicOrModern,
          bpsFemaleOrMale: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.bpsFemaleOrMale
            : getArchetypeByLogin?.data.bpsFemaleOrMale,
          bpsFriendlyOrDistant: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.bpsFriendlyOrDistant
            : getArchetypeByLogin?.data.bpsFriendlyOrDistant,
          bpsNaturalOrIndustrial: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.bpsNaturalOrIndustrial
            : getArchetypeByLogin?.data.bpsNaturalOrIndustrial,
          bpsPlayfulOrSerious: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.bpsPlayfulOrSerious
            : getArchetypeByLogin?.data.bpsPlayfulOrSerious,
          bpsPopularOrElite: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.bpsPopularOrElite
            : getArchetypeByLogin?.data.bpsPopularOrElite,
          bpsRusticOrRefined: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.bpsRusticOrRefined
            : getArchetypeByLogin?.data.bpsRusticOrRefined,
          bpsSimpleOrComplex: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.bpsSimpleOrComplex
            : getArchetypeByLogin?.data.bpsSimpleOrComplex,
          bpsStrippedOrSophisticated: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.bpsStrippedOrSophisticated
            : getArchetypeByLogin?.data.bpsStrippedOrSophisticated,
          bpsSubtleOrExtravagant: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.bpsSubtleOrExtravagant
            : getArchetypeByLogin?.data.bpsSubtleOrExtravagant,
          brandCommunicationStyle: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.brandCommunicationStyle
            : getArchetypeByLogin?.data.brandCommunicationStyle,
          brandCompetitors: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.brandCompetitors
            : getArchetypeByLogin?.data.brandCompetitors,
          brandHistoryAndPurpose: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.brandHistoryAndPurpose
            : getArchetypeByLogin?.data.brandHistoryAndPurpose,
          brandValuesAndMission: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.brandValuesAndMission
            : getArchetypeByLogin?.data.brandValuesAndMission,
          layerMax: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.layerMax
            : getArchetypeByLogin?.data.layerMax,
          layerMin: getArchetypeByLogin?.data[0]
            ? getArchetypeByLogin?.data[0]?.layerMin
            : getArchetypeByLogin?.data.layerMin,
        };

        postLogos();

        const postArchetypeResponse =
          await BrandingArchetypeService.postArchetypeByLogin(bodyNewArchetype);

        notifySuccessCustom("Parametrizações importadas com sucesso");

        navigate("/NewPublicationPageCampaign", {
          state: {
            campaign: true,
            campaignId: bodyNewBusiness.campaignId,
          },
        });
      } else {
        isBranding && setUncompletedSteps((prev) => [...prev, "stepBranding"]);
        isLogo && setUncompletedSteps((prev) => [...prev, "stepLogos"]);
        isCommunication &&
          setUncompletedSteps((prev) => [...prev, "stepVoiceTone"]);
        isEffect && setUncompletedSteps((prev) => [...prev, "stepEffects"]);
        isArchetype &&
          setUncompletedSteps((prev) => [...prev, "StepBrandArchetype"]);
        isPreferences &&
          setUncompletedSteps((prev) => [...prev, "stepVisualPreferences"]);
        isReferences &&
          setUncompletedSteps((prev) => [...prev, "stepVisualReferences"]);

        nextButton("nextNewParameters");
      }
    } else {
      notifyErrorCustom("Erro ao importar parametrizações");
    }
  };

  return (
    <div className={styles.container_header}>
      <Loading enable={loading} />
      <ModalValidParameter
        isOpen={openModal}
        onClose={() => handleCloseModal()}
        handleCloseModal={handleCloseModal}
        campaignItemRef={campaignItemRef}
        wantToKeepParameters={wantToKeepParameters}
      />

      <div className={styles.title_new_posts}>
        <p className={styles.title_new_posts_label}>
          {t("campaignList.campaigns")}
        </p>
        <p className={styles.title_new_posts_title}>
          {t("campaignList.newCampaign")}
        </p>
      </div>

      <div className={styles.container_form}>
        <form className={styles.form_campaign}>
          <div className={styles.container_form_first_options}>
            <div className={styles.container_form_first_options_header}>
              <div
                className={styles.box_button_back}
                onClick={() => {
                  nextButton("back");
                }}
              >
                <LeftBackArrow /> {t("campaignList.back_button")}
              </div>
            </div>
            <div className={styles.form_container_input}>
              <div className={styles.box_input_title}>
                <h2 className={styles.form_container_input_title}>
                  {t("stepNewCampaignSuccess.success")}!
                </h2>
                <p className={styles.form_container_input_sub_title}>
                  {t("stepNewCampaignSuccess.success_description")}
                  &nbsp;
                  <b>
                    {t("stepNewCampaignSuccess.only_edit_what_you_want")}
                  </b>{" "}
                  {t("stepNewCampaignSuccess.from_your_parameterizations")}
                </p>
              </div>
              <div className={styles.container_checkbox}>
                <div className={styles.box_checkbox}>
                  <div
                    className={styles.check_svg}
                    onClick={() => handleCheckt("branding")}
                  >
                    {isBranding ? (
                      <BoxChecket width={20} height={20} color={"#000"} />
                    ) : (
                      <BoxNotChecket
                        width={20}
                        height={20}
                        borderColor={"#000"}
                      />
                    )}
                  </div>
                  <p className={styles.BoxChecket_label}>
                    {t("stepNewCampaignSuccess.branding")}
                  </p>
                </div>

                <div className={styles.box_checkbox}>
                  <div
                    className={styles.check_svg}
                    onClick={() => handleCheckt("logo")}
                  >
                    {isLogo ? (
                      <BoxChecket width={20} height={20} color={"#000"} />
                    ) : (
                      <BoxNotChecket
                        width={20}
                        height={20}
                        borderColor={"#000"}
                      />
                    )}
                  </div>
                  <p className={styles.BoxChecket_label}>
                    {t("stepNewCampaignSuccess.logos")}
                  </p>
                </div>

                <div className={styles.box_checkbox}>
                  <div
                    className={styles.check_svg}
                    onClick={() => handleCheckt("comunicacao")}
                  >
                    {isCommunication ? (
                      <BoxChecket width={20} height={20} color={"#000"} />
                    ) : (
                      <BoxNotChecket
                        width={20}
                        height={20}
                        borderColor={"#000"}
                      />
                    )}
                  </div>
                  <p className={styles.BoxChecket_label}>
                    {t("stepNewCampaignSuccess.communication")}
                  </p>
                </div>

                <div className={styles.box_checkbox}>
                  <div
                    className={styles.check_svg}
                    onClick={() => handleCheckt("efeitos")}
                  >
                    {isEffect ? (
                      <BoxChecket width={20} height={20} color={"#000"} />
                    ) : (
                      <BoxNotChecket
                        width={20}
                        height={20}
                        borderColor={"#000"}
                      />
                    )}
                  </div>
                  <p className={styles.BoxChecket_label}>
                    {t("stepNewCampaignSuccess.effects")}
                  </p>
                </div>

                <div className={styles.box_checkbox}>
                  <div
                    className={styles.check_svg}
                    onClick={() => handleCheckt("arquetipo")}
                  >
                    {isArchetype ? (
                      <BoxChecket width={20} height={20} color={"#000"} />
                    ) : (
                      <BoxNotChecket
                        width={20}
                        height={20}
                        borderColor={"#000"}
                      />
                    )}
                  </div>
                  <p className={styles.BoxChecket_label}>
                    {t("stepNewCampaignSuccess.archetype")}
                  </p>
                </div>

                <div className={styles.box_checkbox}>
                  <div
                    className={styles.check_svg}
                    onClick={() => handleCheckt("preferencias")}
                  >
                    {isPreferences ? (
                      <BoxChecket width={20} height={20} color={"#000"} />
                    ) : (
                      <BoxNotChecket
                        width={20}
                        height={20}
                        borderColor={"#000"}
                      />
                    )}
                  </div>
                  <p className={styles.BoxChecket_label}>
                    {t("stepNewCampaignSuccess.visual_preferences")}
                  </p>
                </div>

                <div className={styles.box_checkbox}>
                  <div
                    className={styles.check_svg}
                    onClick={() => handleCheckt("referencias")}
                  >
                    {isReferences ? (
                      <BoxChecket width={20} height={20} color={"#000"} />
                    ) : (
                      <BoxNotChecket
                        width={20}
                        height={20}
                        borderColor={"#000"}
                      />
                    )}
                  </div>
                  <p className={styles.BoxChecket_label}>
                    {t("stepNewCampaignSuccess.my_references")}
                  </p>
                </div>
              </div>
              <div className={styles.box_buttons}>
                {isBranding === false &&
                  isLogo === false &&
                  isCommunication === false &&
                  isEffect === false &&
                  isArchetype === false &&
                  isPreferences === false &&
                  isReferences === false && (
                    <div
                      onClick={() => {
                        if (
                          verifyParameterizationCompleted.current
                            ?.uncompletedSteps?.length > 0
                        ) {
                          setOpenModal(true);
                          return;
                        }

                        wantToKeepParameters(true);
                      }}
                      className={styles.button_maintain_parameterization}
                      style={{ cursor: "pointer" }}
                    >
                      {t(
                        "stepNewCampaignSuccess.want_to_keep_parameterizations"
                      )}
                    </div>
                  )}

                <div
                  className={styles.button_start_parameterization}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    wantToKeepParameters(false);
                  }}
                >
                  {t("stepNewCampaignSuccess.start_parameterization")}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default StepNewCampaignSuccess;
